import PropTypes from "prop-types";

import { useKeikkaData } from "src/context/KeikkaDataContext";

import { TilausIcon } from "src/components/icons/StepIcons";
import TilausTab_TabCell from "./TilausTab_TabCell";

export default function TilausTabText(props) {
  const isActive = props.isActive || false;
  const isLoading = props.isLoading || false;
  const { keikkaData } = useKeikkaData();
  const hasTila = keikkaData && keikkaData.tila && keikkaData.tila.keikkaTilaSelite;

  return (
    <TilausTab_TabCell
      title="Tilaus"
      icon={<TilausIcon />}
      subtitle={hasTila ? keikkaData.tila.keikkaTilaSelite || "" : ""}
      isLoading={isLoading}
      isActive={isActive}
      disabled={false}
    />
  );
}

TilausTabText.propTypes = {
  isActive: PropTypes.bool,
  isLoading: PropTypes.bool,
};
